import React from 'react';

import { AddInsightToCollectionsActionProps, AddInsightToCollectionsActionType } from '../../shared/types';

import { AddInsightToCollectionsAction } from './AddInsightToCollectionsAction';

export type AddInsightToCollectionsButtonProps<TInsightData extends object, TViewState extends object> = Omit<
  AddInsightToCollectionsActionProps<TInsightData, TViewState>,
  'actionType'
>;

export function AddInsightToCollectionsButton<TInsightData extends object, TViewState extends object>(
  props: AddInsightToCollectionsButtonProps<TInsightData, TViewState>
): JSX.Element {
  return <AddInsightToCollectionsAction {...props} actionType={AddInsightToCollectionsActionType.Button} />;
}
